import { isEcoFoot2Plus, isRM10Evolution, isRM5, isRmGridflex10D, isRmGridflex5Rwdi } from "__common/constants/products";
import { MAX_BLOCK_COUNTS, rm5MaxBlockCount, rmGridflex10MaxBlockCount } from "../utils/constants";

export const apiField = 'max_block_count';

interface MaxBlockCountField {
  type: string;
  apiField: string;
  missing?: any;
  label: string;
  tooltip: () => string;
  data?: MaxBlockCountFieldOption[];
  min: number;
  max: number;
  step?: number;
}

interface MaxBlockCountFieldOption {
  value: string;
  name: string;
}

function makeConfig(max: number = 4, label: string = 'Max Block Count', min : number = 0.5, step: number = 1): MaxBlockCountField {  
  return {
    type: 'Number',
    label,
    apiField,
    tooltip: undefined,
    min,
    max,
    missing:undefined,
    step,
  };
}

export const getMaxBlockCountField = (productId, lowerLimit, half_block_allowed?, fully_attached?, orientation?) => {
  let upperLimit;
  let label;
  let stepIncrement = half_block_allowed ?  0.5 : 1;
  if(isRM10Evolution(productId) || isEcoFoot2Plus(productId)){
    upperLimit = MAX_BLOCK_COUNTS[productId]
    label = "northBayCapacity";
  }
  else if(isRM5(productId)){
    upperLimit = rm5MaxBlockCount(half_block_allowed)
    label = "maxBlockCount";
  }
  else if(isRmGridflex10D(productId)){
    upperLimit = rmGridflex10MaxBlockCount(half_block_allowed, orientation)
    label = "maxBlockCount";
  }
  else if(isRmGridflex5Rwdi(productId)){
    upperLimit = 5;
    label = "maxBlockCount";
  }
  if(lowerLimit >= upperLimit){
    lowerLimit = upperLimit
    stepIncrement = 0
  }
  return makeConfig(upperLimit, label, lowerLimit+stepIncrement, stepIncrement);
};


